export const AcademicoTurmas = {
  // Letter A:
  ADICIONAR_DISCIPLINA: 'Add subjects to the class',

  // Letter E:
  EDITAR_DISCIPLINA: 'Edit Subject',
  EDITAR_TURMA: 'Edit Class',

  // Letter N:
  NOVA_TURMA: 'New Class',

  // Letter T:
  TURMA_DESCRICAO_EDITAR: 
    'On this screen, you can update the class information',
  TURMA_DESCRICAO_NOVO: 
    "Creating a class is simple! Fill out the form below and then click the 'save' button at the end:",
};
